// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleInputChange(event) {

    this.onItemChange(this.propertyToUpdate, event.target.value);

}

const InputField = props =>
    <div className='labeled-string'>
        <span className='data-label asterisk-after'>
            <FormattedMessage id={props.label}/>
        </span>
        <input
            onChange={props::handleInputChange}
            type='text'
        />
    </div>;

InputField.displayName = 'InputField';
InputField.propTypes = {
    label: PropTypes.string.isRequired,
    onItemChange: PropTypes.func.isRequired,
    propertyToUpdate: PropTypes.string.isRequired
};

export default InputField;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/form-fields/input-field.js